export const ROOT = 'Package/listPackage/packages';

export const FETCH_PACKAGE_REQUEST = `${ROOT}/FETCH_PACKAGE_REQUEST`;
export const FETCH_PACKAGE_FAILURE = `${ROOT}/FETCH_PACKAGE_FAILURE`;
export const FETCH_PACKAGE_SUCCESS = `${ROOT}/FETCH_PACKAGE_SUCCESS`;

export const PUBLISH_PACKAGE_REQUEST = `${ROOT}/PUBLISH_PACKAGE_REQUEST`;
export const PUBLISH_PACKAGE_FAILURE = `${ROOT}/PUBLISH_PACKAGE_FAILURE`;
export const PUBLISH_PACKAGE_SUCCESS = `${ROOT}/PUBLISH_PACKAGE_SUCCESS`;

export const SET_CATEGORY_PACKAGE = `${ROOT}/SET_CATEGORY_PACKAGE`;
export const SET_ID_PACKAGE = `${ROOT}/SET_ID_PACKAGE`;

export const CLEAR_PUBLISH_PACKAGE_DATA = `${ROOT}/CLEAR_PUBLISH_PACKAGE_DATA`;
export const CLEAR_PACKAGE_DATA = `${ROOT}/CLEAR_PACKAGE_DATA`;
export const CLEAR_PACKAGE_CONSUME_DATA = `${ROOT}/CLEAR_PACKAGE_CONSUME_DATA`;

export const FETCH_PACKAGE_CONSUME_REQUEST = `${ROOT}/FETCH_PACKAGE_CONSUME_REQUEST`;
export const FETCH_PACKAGE_CONSUME_FAILURE = `${ROOT}/FETCH_PACKAGE_CONSUME_FAILURE`;
export const FETCH_PACKAGE_CONSUME_SUCCESS = `${ROOT}/FETCH_PACKAGE_CONSUME_SUCCESS`;